<form [formGroup]="addPipeSpecCombinationForm" (ngSubmit)="addButtonClick()">
    <div class="modal-header">
        <h4>{{ tittle }}</h4>
        <a class="close-icon" href="javascript:void()" (click)="closeClick()" ngbAutofocus><i class="flaticon2-cross"></i></a>
    </div>
    <div class="modal-body output-lable new-user">
        <div class="code_details_title d-flex justify-content-end">
            <div class="row">
                <div class="title-wrap">
                    <h4>
                        {{ 'SETTING_PAGE.IDMS_SETTINGS.PIPE_SPECIFICATION_CODE' | transloco }}<span>{{ selectedPipeCode.name }}</span>
                    </h4>
                </div>
            </div>
        </div>

        <div class="row mb-3 mt-3">
            <div class="col-md-4">
                <mat-label class="font-style d-flex align-items-center h-100">{{ 'SETTING_PAGE.IDMS_SETTINGS.COMBINATION_NAME' | transloco }}</mat-label>
            </div>
            <div class="col-md-8">
                <mat-form-field [floatLabel]="'never'" class="custom-text-field w-100">
                    <input
                        matInput
                        type="text"
                        placeholder="{{ 'SETTING_PAGE.IDMS_SETTINGS.ENTER_COMBINATION_NAME' | transloco }}"
                        formControlName="CombinationName"
                    />
                </mat-form-field>
            </div>
        </div>
        <div class="row mb-3" *ngIf="mode == 'Add'">
            <div class="col-md-4">
                <mat-label class="font-style d-flex align-items-center h-100">{{ 'SETTING_PAGE.IDMS_SETTINGS.CALCULATION_TYPE' | transloco }} </mat-label>
            </div>
            <div class="col-md-8">
                <mat-select
                    name="calculation type"
                    class="dropdown-wrapper"
                    panelClass="dropdown-wrapper"
                    [class.spinner]="false"
                    formControlName="CalculationType"
                >
                    <mat-option [value]="0" class="option-list">{{ 'SETTING_PAGE.IDMS_SETTINGS.STANDARD_FLANGE' | transloco }}</mat-option>
                    <mat-option [value]="2" class="option-list" s>{{ 'SETTING_PAGE.IDMS_SETTINGS.CLAMP' | transloco }}</mat-option>
                </mat-select>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn primary-ebtn" [disabled]="!addPipeSpecCombinationForm.valid || !addPipeSpecCombinationForm.dirty">
                {{ mode == 'Add' ? ('SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco) : ('SETTING_PAGE.IDMS_SETTINGS.EDIT' | transloco) }}
            </button>
            <button type="button" class="btn secondary-ebtn" (click)="closeClick()">{{ 'SETTING_PAGE.IDMS_SETTINGS.CANCEL' | transloco }}</button>
        </div>
    </div>
</form>
